import React from "react";

export const TakeoutContext = React.createContext();
